import { navigate } from '@reach/router';
import React, { useEffect, useRef, useState } from 'react';
import { useWindowDimensions } from '../../../../../utilities/Dimensions';
import { desktopscreensize } from '../../../../../utilities/constants';
import { Icon } from '../../../../../utilities/icomoon-css';
import {
  ExitModal,
  UserDetailsSection,
} from '../../../../account/helpers/LayoutComponents';
import { NavBarTypes } from '../navBarTypes';
import { DashboardAndLogOutSection } from './SignInAvatarHelpers';

export const TenantAvatar = ({
  globalContext,
  logOutHandler,
  accountSelectionUrl,
  currentLocation,
  siteType,
}: NavBarTypes.TTenantAvatarTypes) => {
  const { userName = '', bodyHeight, tenantName = {} } = globalContext;
  const { last_name = '', first_name = '' } = tenantName;
  const [isOpen, setIsOpen] = useState(false);
  const [showExistModal, setShowExistModal] = useState(false);
  const [isBurgerEnabled, setIsBurgerEnabled] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const { width } = useWindowDimensions();

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        dropdownRef?.current &&
        !dropdownRef?.current?.contains(event?.target)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (width < desktopscreensize) setIsBurgerEnabled(true);
  }, [width]);

  const toggleDropdown = () => {
    if (!isBurgerEnabled) setIsOpen(prevState => !prevState);
  };

  const logOutLinkHandler = () => {
    setShowExistModal(!showExistModal);
  };

  const closeModal = () => {
    setShowExistModal(false);
  };

  const handleAvatarClickInMobileScreens = () => {
    if (isBurgerEnabled) navigate(accountSelectionUrl);
  };

  const renderMultiLocationAvatar = () => {
    const { location_name } = currentLocation || {};
    return (
      <div className="multiSignInAvatarContainer" onClick={toggleDropdown}>
        <div className="avatar is-size-4 has-background-primary has-text-white multiAvatar">
          {last_name ? last_name[0].toUpperCase() : ''}
          {first_name ? first_name[0].toUpperCase() : ''}
        </div>
        <div>
          <div className="multiTenanatName">
            {last_name ? last_name : ''} {first_name ? first_name : ''}
          </div>
          <div className="multiTenanatLocation">
            <Icon
              name="tfw-facility-cp"
              size={12}
              color="#fff"
              title="tfw-facility-cp"
            />
            <span className="locationNameMulti">{location_name}</span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div
        className="dropdown"
        ref={dropdownRef}
        onClick={handleAvatarClickInMobileScreens}
      >
        <div
          className="dropdown-trigger"
          style={{ ...(isBurgerEnabled ? { display: 'flex' } : {}) }}
        >
          {siteType === 'multi' ? (
            renderMultiLocationAvatar()
          ) : (
            <div
              className="avatar is-size-4 has-background-primary has-text-white"
              onClick={toggleDropdown}
            >
              {last_name ? last_name[0].toUpperCase() : ''}
              {first_name ? first_name[0].toUpperCase() : ''}
            </div>
          )}
          {isBurgerEnabled && (
            <>
              <div className="avatarViewAccount">
                <p className="subtitle1">
                  {last_name ? last_name : ''} {first_name ? first_name : ''}
                </p>
                <div>View account</div>
              </div>
              <div className="avatarRightArrow">
                <Icon
                  name={'tfw-arrow-right-2-cp'}
                  size={12}
                  title={'tfw-arrow-right-2-cp'}
                />
              </div>
            </>
          )}
        </div>
        {isOpen ? (
          <div
            className={`dropdownMenu${isOpen ? ' is-active' : ''}`}
            id="dropdown-menu"
            role="menu"
          >
            <div className="dropdown-content">
              <UserDetailsSection
                name={tenantName}
                email_address={{
                  is_email_enabled: true,
                  email_address: userName,
                }}
                siteType={siteType}
                currentLocation={currentLocation}
              />
              <hr className="horizontalTag" />
              <DashboardAndLogOutSection
                onClickHandler={() => navigate(accountSelectionUrl)}
                iconName={'tfw-dashboard-cp'}
                label={'Your Dashboard'}
              />
              <hr className="horizontalTag" />
              <DashboardAndLogOutSection
                onClickHandler={logOutLinkHandler}
                iconName={'tfw-logout-cp'}
                label={'Log Out'}
              />
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
      {showExistModal && (
        <ExitModal
          bodyHeight={bodyHeight}
          hideModal={closeModal}
          logOutHandler={logOutHandler}
        />
      )}
    </>
  );
};
